export const switchButtons = [
  {
    name: 'All Races',
    type: 'upComing',
  },
  {
    name: 'Results',
    type: 'result',
  },
];
